function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    let str = decodeURI(window.location)
    let index = str.indexOf("?");
    str  = str.substring(index + 1, str .length);
    r = str.match(reg);
    if (r != null) {
      return decodeURI(r[2]);
    }else{
      return "";
    }
  }
}

function guid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
}

var searchParam = {
  que_name: "",
  que_tags: "",
  difficulty: "",
  contain_answer: "",
  curpage: 1,
  pagesize: 20
}

export default {
  GetQueryString,
  guid,
  searchParam
};
